<template>
    <custom-table
        :title="$t('pages.ecommerce.user.creator.title')"
        :subTitle="$t('pages.ecommerce.user.creator.subTitle')"
        :items="table.data"
        :loading="table.loading"
        :columns="fields"
        :actions="actions"
        :pagination="table.pagination"
        @action="handleClickAction"
        @changeTable="handleTableChange">
        <template v-slot:state="{ row: record }">
            <span :class="status[record.status_id].badge" class="badge">{{ $t('pages.ecommerce.user.creator.status.' + status[record.status_id].code) }}</span>
        </template>
        <template v-slot:completedAt="{ row: record }">
            {{ record.completed_at ? $moment(record.completed_at).format("DD.MM.YYYY - HH:mm:ss") : "-" }}
        </template>
        <template v-slot:createdAt="{ row: record }">
            {{ $moment(record.created_at).format("DD.MM.YYYY - HH:mm:ss") }}
        </template>
        <template v-slot:actions="{ row: record }">
            <div class="d-flex justify-content-end">
                <a v-on:click="exportRecord(record)" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1" v-if="record.status_id == 3">
                    <span class="svg-icon svg-icon-3">
                        <inline-svg src="/media/icons/duotune/files/fil021.svg"/>
                    </span>
                </a>
            </div>
        </template>
    </custom-table>

    <div class="modal fade" id="kt_modal_user_creator" ref="userCreatorModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered mw-650px">
            <div class="modal-content">
                <div class="modal-header" id="kt_modal_change_password_header">
                    <h2 class="fw-bolder">{{ form.title }}</h2>
                    <div id="kt_modal_change_password_close" data-bs-dismiss="modal" class="btn btn-icon btn-sm btn-active-icon-primary">
                        <span class="svg-icon svg-icon-1">
                            <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
                        </span>
                    </div>
                </div>
                <el-form @submit.prevent="onSubmit()" :model="form.data" ref="userCreatorForm">
                    <div class="modal-body py-10 px-lg-17">
                        <div class="scroll-y me-n7 pe-7" id="kt_modal_change_password_scroll" data-kt-scroll="true" data-kt-scroll-activate="{default: false, lg: true}" data-kt-scroll-max-height="auto" data-kt-scroll-dependencies="#kt_modal_add_customer_header" data-kt-scroll-wrappers="#kt_modal_add_customer_scroll" data-kt-scroll-offset="300px">
                            <div class="notice d-flex bg-light-warning rounded border-warning border border-dashed mb-10 p-6">
                                <span class="svg-icon svg-icon-2tx svg-icon-warning me-4">
                                    <inline-svg src="/media/icons/duotune/general/gen044.svg" />
                                </span>
                                <div class="d-flex flex-stack flex-grow-1">
                                    <div class="fw-bold">
                                        <div class="fs-6 text-gray-600" v-html="sprintf($t('pages.ecommerce.user.creator.messages.template'), [templateUrl])"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="fv-row mb-7">
                                <label class="fs-6 fw-bold mb-2">{{ $t('pages.ecommerce.user.creator.cols.upload.title') }}</label>
                                <el-form-item prop="file">
                                    <el-upload :file-list="form.fileList" accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" class="upload-file" :on-change="handleChangeFile" :on-remove="handleChangeFile" :auto-upload="false" drag :multiple="false" :limit="1">
                                        <el-icon class="el-icon--upload">
                                             <span class="svg-icon">
                                                 <inline-svg src="/media/icons/duotune/files/fil022.svg" />
                                             </span>
                                        </el-icon>
                                        <div class="el-upload__text">{{ $t('pages.ecommerce.user.creator.cols.upload.dragFile')}}</div>
                                    </el-upload>
                                </el-form-item>
                            </div>
                            <div class="fv-row mb-7">
                                <div class="rounded h-100 bg-light px-8 py-10">
                                    <div class="pb-5">
                                        <h2 class="fw-bold text-dark">{{ $t('pages.ecommerce.user.creator.messages.title') }}</h2>
                                    </div>
                                    <div class="pt-1 fs-7">
                                        <div class="d-flex align-items-center" v-for="index in 7" :key="index" :class="index != 0 && 'mt-4'">
                                            <span class="svg-icon svg-icon-2 svg-icon-success me-3">
                                                <inline-svg src="/media/icons/duotune/general/gen043.svg"/>
                                            </span>
                                            <span class="fw-semobold text-gray-700 flex-grow-1" v-html="$t('pages.ecommerce.user.creator.messages.message' + index)"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer flex-center">
                        <button :data-kt-indicator="form.loading ? 'on' : null" class="btn btn-lg btn-primary" type="submit" :disabled="form.loading">
                            <span v-if="!form.loading" class="indicator-label">{{ $t("btn.save") }}</span>
                            <span v-if="form.loading" class="indicator-progress">
                                {{  $t("messages.wait") }}
                                <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
    <div class="modal fade" id="kt_modal_export_filter" ref="exportFilterModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered mw-650px">
            <div class="modal-content">
                <div class="modal-header" id="kt_modal_export_filter_header">
                    <h2 class="fw-bolder">{{ form.title }}</h2>
                    <div id="kt_modal_export_filter_close" data-bs-dismiss="modal" class="btn btn-icon btn-sm btn-active-icon-primary">
                        <span class="svg-icon svg-icon-1">
                            <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
                        </span>
                    </div>
                </div>
                <el-form @submit.prevent="onExportFilter()" :model="form.export.filter" ref="exportFilterForm">
                    <div class="modal-body py-10 px-lg-17">
                        <div class="scroll-y me-n7 pe-7" id="kt_modal_export_filter_scroll" data-kt-scroll="true" data-kt-scroll-activate="{default: false, lg: true}" data-kt-scroll-max-height="auto" data-kt-scroll-dependencies="#kt_modal_add_customer_header" data-kt-scroll-wrappers="#kt_modal_add_customer_scroll" data-kt-scroll-offset="300px">
                            <div class="notice d-flex bg-light-warning rounded border-warning border border-dashed mb-10 p-6">
                                <span class="svg-icon svg-icon-2tx svg-icon-warning me-4">
                                    <inline-svg src="/media/icons/duotune/general/gen044.svg" />
                                </span>
                                <div class="d-flex flex-stack flex-grow-1">
                                    <div class="fw-bold">
                                        <div class="fs-6 text-gray-600">{{ $t('pages.ecommerce.user.creator.messages.export') }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="fv-row mb-7">
                                <label class="fs-6 fw-bold mb-2">{{ $t('common.status') }}</label>
                                <el-form-item prop="status_ids">
                                    <el-select v-model="form.export.filter.status_ids" class="w-100" :placeholder="$t('common.chooseSelect')" clearable multiple>
                                        <el-option v-for="(state, stateIndex) in exportStatus" :key="stateIndex" :value="(stateIndex + 1)" :label="$t('pages.ecommerce.user.creator.exportStatus.' + state)"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer flex-center">
                        <button :data-kt-indicator="form.loading ? 'on' : null" class="btn btn-lg btn-primary" type="submit" :disabled="form.loading">
                            <span v-if="!form.loading" class="indicator-label">{{ $t("common.export") }}</span>
                            <span v-if="form.loading" class="indicator-progress">
                                {{  $t("messages.wait") }}
                                <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import CustomTable from "@/components/custom-table";
export default {
    name: "index",
    components: {
        CustomTable
    },
    data(){
        return {
            fields: [
                {
                    name: this.$t("common.id"),
                    key: "id",
                    class: ""
                },
                {
                    name: this.$t("pages.ecommerce.user.creator.cols.creator"),
                    key: "admin.full_name"
                },
                {
                    name: this.$t("pages.ecommerce.user.creator.cols.totalUser"),
                    key: "total"
                },
                {
                    name: this.$t("pages.ecommerce.user.creator.cols.success"),
                    key: "success"
                },
                {
                    name: this.$t('common.status'),
                    scopedSlots: {customRender: "state"}
                },
                {
                    name: this.$t("pages.ecommerce.user.creator.cols.completedAt"),
                    scopedSlots: {customRender: "completedAt"}
                },
                {
                    name: this.$t("common.createdAt"),
                    scopedSlots: {customRender: "createdAt"}
                },
                {
                    name: this.$t("common.action"),
                    key: "action",
                    scopedSlots: {customRender: "actions"}
                }
            ],
            actions: [
                {
                    name: "new",
                    icon: "bi-plus-lg",
                    label: "btn.add"
                },
                {
                    name: "refresh",
                    icon: "bi-arrow-repeat",
                    label: "btn.refresh"
                }
            ],
            form: {
                title: '',
                loading: false,
                updateStatus: false,
                file: {
                    list: [],
                    uploadList: []
                },
                export: {
                    filter: {}
                },
                data: {}
            },
            status: {
                1: {
                    code: 'pending',
                    badge: 'badge-primary'
                },
                2: {
                    code: 'processing',
                    badge: 'badge-info'
                },
                3: {
                    code: 'completed',
                    badge: 'badge-success'
                }
            },
            exportStatus: ['pending', 'created', 'already_exist', 'error'],
            templateUrlPattern: "%s/system/template/user_creator_example.xlsx"
        }
    },
    computed: {
        table() {
            return this.$store.state.ecommerce.user.creator.table;
        },
        templateUrl(){
            return this.sprintf(this.templateUrlPattern, [this.$root.appUrl]);
        }
    },
    mounted() {
        this.setCurrentPageBreadcrumbs(this.$t("menu.userCreator"), [this.$t("menu.ecommerceManagement"), this.$t("menu.userManagement")]);
        this.$store.dispatch('ecommerce/user/creator/get', {
            page: {},
            filterData: {
                sort: 'id:desc',
            }
        });
    },
    methods: {
        newRecord(){
            this.form.updateStatus = false;
            this.form.data = {};
            this.form.title = this.$t("pages.ecommerce.user.creator.new");
            this.showModal(this.$refs.userCreatorModal);
        },
        onSubmit() {
            if(!(this.form.file.uploadList.length > 0)){
                this.$notify({
                    type: 'warning',
                    title: this.$t("messages.warning"),
                    message: this.$t("pages.ecommerce.user.creator.warnings.requiredFile"),
                })
                return false;
            }

            this.form.loading = true;

            const formData = new FormData();

            this.form.file.uploadList.forEach(file => {
                formData.append("file", file.raw);
            });

            this.axios.post(this.endpoints['user_creator'], formData).then(response => {
                this.onResponse(response.data, () => {
                    this.refreshTable();
                    this.hideModal(this.$refs.userCreatorModal);
                }, () => {
                    this.form.loading = false;
                });
            }).catch(error => {
                this.onResponseFailure(error.response.data, () => {
                    this.form.loading = false;
                });
            });
        },
        handleClickAction(name) {
            switch (name) {
                case "refresh":
                    this.refreshTable();
                    break;

                case "new":
                    this.newRecord();
                    break;

                default:
                    break;
            }
        },
        refreshTable() {
            this.$store.dispatch("ecommerce/user/creator/refresh");
        },
        handleTableChange(pagination, filterData) {
            this.$store.dispatch("ecommerce/user/creator/get", {
                page: pagination,
                filterData: Object.assign({
                    sort: 'id:desc',
                }, filterData)
            });
        },
        handleChangeFile(file, fileList){
            this.form.file.uploadList = fileList;
        },
        exportRecord(record){
            this.form.updateStatus = false;
            this.form.export = {
                id: record.id,
                filter: {}
            };
            this.form.title = this.$t("pages.ecommerce.user.creator.exportFilter");
            this.showModal(this.$refs.exportFilterModal);
        },
        onExportFilter() {
            this.form.loading = true;
            this.axios({
                url: this.sprintf('%s/%d', [this.endpoints['user_creator_export'], this.form.export.id]),
                method: 'get',
                responseType: "blob",
                params: this.form.export.filter
            }).then(response => {
                const type = response.headers['content-type']
                const blob = new Blob([response.data], {type: type, encoding: 'UTF-8'})
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.click();

                this.hideModal(this.$refs.exportFilterModal);
            }).finally(() => {
                this.form.loading = false;
            });
        }
    }
}
</script>

<style>
.upload-file .el-upload {
    width: 100%;
}

.upload-file .el-upload .el-upload-dragger{
    width: 100%;
}

.upload-file .svg-icon svg {
    height: 1em;
    width: 1em;
}
</style>